import { CategoriesApi, EventsApi } from "@/api";
import { categories, stateRefs } from "@/constants";
const { MAIN, SUB } = categories[stateRefs.category].types;

const loadMainCategories = async (options = {}) => {
  const specParams = {
    type: MAIN,
    limit: options.limit || 10,
    offset: options.offset || 0,
    q: options.q || undefined,
    hidden: false,
    archived: false,
  };

  return CategoriesApi.getCategories(specParams)
    .then((response) => response.items.map((item) => ({ id: item.id, name: item.attributes.name })))
    .catch((error) => {
      console.error("Error getting main categories:", error);
      throw error;
    });
};

const loadSubCategories = async (options = {}) => {
  const specParams = {
    type: SUB,
    limit: options.limit || 10,
    offset: options.offset || 0,
    q: options.q || undefined,
    hidden: false,
  };

  return CategoriesApi.getCategories(specParams)
    .then((response) => response.items.map((item) => ({ id: item.id, name: item.attributes.name })))
    .catch((error) => {
      console.error("Error getting sub categories:", error);
      throw error;
    });
};

const loadProvince = async (options = {}) => {
  const search = options.q || undefined;

  const provinces = EventsApi.eventProvinces.filter((province) => {
    if (search) {
      return province.name.toLowerCase().includes(search.toLowerCase());
    }

    return true;
  });

  return new Promise((resolve) => {
    resolve(provinces);
  });
};

export const loadOptionsHelper = async ({ optionsId, tenant, ...options }) => {
  switch (optionsId) {
    case "main-categories":
      return await loadMainCategories({ tenant, ...options });
    case "sub-categories":
      return await loadSubCategories({ tenant, ...options });
    case "province":
      return await loadProvince(options);
    default:
      console.warn(`Unknown options ID: ${optionsId}`);
      return [];
  }
};

export const getListOfCategoriesByIds = (ids) => {
  return CategoriesApi.getCategories({
    ids,
    limit: 100,
    hidden: false,
    archived: false,
  });
};
